export default __webpack_public_path__ + "static/media/half-circle.8fbeec05.svg";